import { DatePipe, DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CruiseService } from '../services/cruise.service';
import { LandingPageService } from '../services/landingpage.service';
import { Title, Meta } from '@angular/platform-browser';
import { Component, OnInit, PLATFORM_ID, Inject, AfterViewInit } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';
import { animate, style, transition, trigger } from '@angular/animations';

declare var $: any;
declare var jQuery: any;
declare var window: any;
@Component({
  selector: 'app-availbility',
  templateUrl: './availbility.component.html',
  styleUrls: ['./availbility.component.css'],
  animations: [
    trigger('readAnim', [
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('.150s linear', style({ height: 0, opacity: 0 }))
      ]),
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('.150s linear', style({ height: '*', opacity: 1 }))
      ])
    ])
  ]
})
export class AvailbilityComponent implements OnInit {
  title = 'Cruize';
  availableCruises: any[] = [];
  selectedCruise: any = {
    gallery: [],
    policies: {}
  };
  public choosdeck: any = "";
  public decimg: any = "";
  public deckPlanscheck: any = ""; filtership: string[] = [];
  filteredCruises: any[] = [];
  selectedCruises: any[] = [];
  filterMonths: string[] = [];
  selectedMonths: string[] = [];
  tabval: any = "";
  minPrice: number = 0;
  maxPrice: number = 1000;
  selectedMinPrice: number = 0;
  selectedMaxPrice: number = this.maxPrice;
  catename: string = "";
  allCabins: any;
  filterNights: string[] = [];
  selectedNights: string[] = []; public apiProviders: any[] = [];

  filterDestinations: string[] = [];
  selectedDestinations: string[] = [];
  selectedCruiseArray: string[] = [];

  cruiseLineSorted: boolean = false;
  cruiseLengthSorted: boolean = false;
  priceSorted: boolean = false;
  public checkterm: any = '';
  place: string = ""; loginMobile = "";
  sailDate: string = "";
  duration: string = ""; private merchantsetup: any = {};
  cruiseLine: string = ""; cruiseCode: string = ""; MoreInfo: string = ""; MoreInfoShort: string = ""; faqArray: string[] = [];
  searchString: string = "";
  contactb2c: string = ''; contactb2b: string = '';
  whatsAppUrl: any = "https://api.whatsapp.com/send?phone=918879890076";
  //whatsAppUrl: any = "https://api.whatsapp.com/send?phone=918879890076";
  activeRoom: any = {
    type: "Interior",
    adults: 2,
    childs: 0,
    infants: 0
  };
  lead: any = {
    name: "",
    email: "",
    phone: "",
    city: "",
    cruiseName: ""
  };
  searchData: any = {}; AgentUserLoginId: any = ''; public loginType = ''; whatsappmsg: any = ''; logindata: any = ''; public agentcode: any = "";
  private cruiseapi: any = 'offline'; orgsearchData: any = {}; pagetitle: any = ''; isDest: any = "N";
  showMore: boolean = false; fullURL: any = ''; baseURL: any = ''; cruiseplace: any = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private route: ActivatedRoute, private landingPageService: LandingPageService,
    private toastr: ToastrService, private sanatize: DomSanitizer, private cruiserService: CruiseService,
    platformLocation: PlatformLocation, private routr: Router, private titleService: Title, private meta: Meta, @Inject(DOCUMENT) private dom) {
    // Get Agent Login
    this.fullURL = (platformLocation as any).location.href; this.baseURL = (platformLocation as any).location.origin;
    this.loginType = this.cruiserService.getloginType();
    this.merchantsetup = this.cruiserService.getSetupData();
    if (this.loginType == "B2C") { this.whatsAppUrl = "https://api.whatsapp.com/send?phone=918657986515"; this.contactb2c = "+91 22 6881 8888 " }
    else { this.whatsAppUrl = "https://api.whatsapp.com/send?phone=918652638054"; this.contactb2c = "+918652638054" }
    try {
      if (isPlatformBrowser(this.platformId)) {
        if (sessionStorage.getItem("logindata")) {
          this.logindata = JSON.parse(JSON.parse(sessionStorage.getItem("logindata")));
          this.AgentUserLoginId = this.logindata.AgentUserLoginId;
        }
      }
    } catch (errormsg) { console.log(errormsg) };

    this.getParams();

  }

  getParams() {
    this.route.params.subscribe(params => {
      this.searchString = params["searchstring"];
      let parameters = this.searchString.split("---");
      if (parameters.length > 2) {
        this.place = parameters[0];
        this.sailDate = parameters[1];
        this.duration = parameters[2];
        this.cruiseLine = parameters[3];
        this.cruiseCode = parameters[4];
        this.pagetitle = this.cruiseLine + "Packages"; this.cruiseplace = "";
        this.getavailability();
      }
      else {
        if (parameters[0] != "") {
          this.landingPageService.checkDest(parameters[0]).subscribe(
            data => {
              let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
              if (resp.status == "success") {
                this.place = parameters[0].split('-')[0];
                this.sailDate = "";
                this.duration = "";
                this.cruiseLine = "";
                this.cruiseCode = ""; this.cruiseplace = resp.cruiseLines;
                this.getavailability();
              } else {
                this.place = "";
                this.sailDate = "";
                this.duration = "";
                this.cruiseLine = parameters[0];
                this.cruiseCode = ""; this.cruiseplace = "";
                this.getavailability();
              }
            },
            error => {
              console.log(error);
            }
          )

        } else {
          this.place = "";
          this.sailDate = "";
          this.duration = "";
          this.cruiseLine = parameters[0];
          this.cruiseCode = ""; this.cruiseplace = "";
          this.getavailability();
        }
      }


    })

  }

  getavailability() {
    // try {
    //   this.searchString = params["searchstring"];
    //   let destination = params["destination"];
    //   if (destination) {
    //     this.place = destination.split('-')[0];
    //     this.sailDate = "";
    //     this.duration = "";
    //     this.cruiseLine = "";
    //     this.cruiseCode = "";
    //   }
    // } catch (errormsg) {
    //   console.log("");
    // }
    if (this.merchantsetup) {
      this.cruiseapi = this.merchantsetup.cruiseapi;
    } else {
      this.cruiseapi = environment.cruiseapi;
    }
    this.apiProviders = this.cruiseapi.split(',');

    if (this.cruiseCode != "") {
      this.getCruiseAvailability("cruisecode");
    }
    else if (this.cruiseLine != "") {
      this.getCruiseAvailability("cruisename");
    }
    else if (this.cruiseplace != "") {
      var arCruise = this.cruiseplace.split(',');
      for (var i = 0; i < arCruise.length; i++) {
        this.getCruiseAvailability(arCruise[i]);
      }
    }
    else {
      for (var i = 0; i < this.apiProviders.length; i++) {
        this.getCruiseAvailability(this.apiProviders[i]);
      }
    }
  }

  showdiv(i, event) {
    if (i == 0) {
      jQuery("#collapseTwo0").toggleClass('show');
    }
    else {
      jQuery(event.target.target).toggleClass('show');
    }
    // if (this.tabval != event.target.target) { jQuery(this.tabval).remove(); }
    // if (this.tabval == event.target.target) { jQuery(event.target.target).remove(); }
    this.tabval = event.target.target;
  }

  getCruiseAvailability(api) {
    // Added one more index for the Cruise
    var data = "";
    data = this.place + "()" + this.sailDate + "()" + this.duration + "()";

    data = data + this.cruiseLine + "()" + this.cruiseCode;
    // Last index for the availability on all parameters like Rooms etc.
    //1~Jan-2021~3~4,2A,1C,0I|[~B2C[https://jagsons.in[voyagelist
    data = data + "()" + "Interior,Interior,2A,0C,0I|";
    //jQuery("#waitingIcon").modal("show");
    this.landingPageService.getCruiseAvailability(data, this.loginType, this.agentcode, this.AgentUserLoginId, api).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.search) {
          this.searchData = resp.search[0];
          this.orgsearchData = resp;
        }
        if (resp.cruiseAvailability) {
          var flights = resp.cruiseAvailability;
          for (var i = 0; i < flights.length; i++) {
            this.availableCruises.push(flights[i])
          }

          // this.availableCruises = resp.cruiseAvailability;
          this.afterDataLoad();

          try {
            this.filterDestinations = this.orgsearchData.allPorts; this.filterDestinations.sort();
            this.allCabins = this.orgsearchData.allCategories; this.filterMonths = this.orgsearchData.allsailMonths;
            this.showclass(this.allCabins[0].category);
          }
          catch (errormsg) { }

          // Add Meta Tags
          try {
            // if (this.orgsearchData.TitleTag == "") this.titleService.setTitle("Book Cruise Tour Packages with Akbar Travels"); else
            //   this.titleService.setTitle(this.orgsearchData.TitleTag);
            if (this.orgsearchData.cruiseAvailability.length > 0) {
              if (this.loginType == "B2C") {

                if (this.orgsearchData.MetaKeyword != '') {
                  // Remove Tags first
                  this.meta.removeTag('Keywords');
                  this.meta.removeTag('Description');
                  this.meta.removeTag('H1'); this.meta.removeTag('author');

                  this.meta.addTag({ name: 'author', content: 'http://www.influencetechnolabs.com/' });
                  this.meta.addTag({ name: 'Keywords', content: this.orgsearchData.MetaKeyword });
                  this.meta.addTag({ name: 'Description', content: this.orgsearchData.MetaDescription });
                  this.meta.addTag({ name: 'H1', content: this.orgsearchData.MetaDescription });
                  this.titleService.setTitle(this.orgsearchData.TitleTag);
                  this.MoreInfo = this.orgsearchData.MoreInfo;
                  this.MoreInfoShort = this.orgsearchData.MoreInfoShort;
                  this.faqArray = this.orgsearchData.faqSection;
                  sessionStorage.setItem("orgsearchData", JSON.stringify(this.orgsearchData))
                  this.createCanonicalLink(this.fullURL);
                }
              }

              // const viewport = this.meta.getTag('name=Keywords');
              // console.log(viewport.content);
            }

          } catch (errormsg) { }



        } else {
          this.toastr.info("Some Cruises may not be available for given Criteria ...")
        }
      },
      error => {
        console.log(error);
      }
    )
  }
  showclass(catname) {
    this.catename = catname;
  }
  checkDestination(cruiseline) {

    this.landingPageService.checkDest(cruiseline).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == "success") {
          this.isDest = "Y";
        } else {
          this.isDest = "N";
        }
      },
      error => {
        console.log(error);
      }
    )
  }

  modifySearch() {
    this.filteredCruises = [];
    this.availableCruises = [];
    this.getParams();
    if (isPlatformBrowser(this.platformId)) {
      this.activeRoom = JSON.parse(sessionStorage.getItem("room"));
    }
  }

  ngOnInit() {
    // this.getCruiseAvailability();
    window.scrollTo(0, 0);
    jQuery("#waitingIcon").modal("show");
    $("#menu").menu();
    this.whatsAppUrl = this.sanatize.bypassSecurityTrustUrl(this.whatsAppUrl);
    this.meta.addTag({ name: 'author', content: 'http://www.influencetechnolabs.com/' });

    $("#myTab-3").on("click", "li", function (event) {
      $('#myTab-3').parents().eq(2).css({
        "display": "block"
      });
      $('#staterooms-li').addClass('resp-tab-active');
    });

    $('.cruise-info-tab').on("click", function (event) {
      $('#myTab-3').parents().eq(2).css({
        "display": "none"
      });
    });

    // $('#close-dialog').on('click', function (event) {
    //   $("ul.resp-tabs-list > li").removeClass("resp-tab-active");     

    // })

    $('#verticalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
    });

    // $("#readMore").click(function () {
    //   $("#readMoreWraper").css(
    //     "opacity", "0"
    //   )
    //   $("#collapseExample").slideDown("slow", function () {
    //     // Animation complete.
    //   });
    // });
    // // function readMore() {
    // $("#readLess").click(function () {
    //   $("#readMoreWraper").css(
    //     "opacity", "1"
    //   )
    //   $("#collapseExample").slideUp("slow", function () {
    //     // Animation complete.
    //   });
    // });
    // // }


  }

  toggleShare() {
    if (this.selectedCruises.length > 0)
      document.getElementById("open-hide").classList.toggle('show');
  }

  selectCruise(ev, cruise) {
    if (ev.target.checked) {
      console.log("checked");
      if (this.selectedCruises.indexOf(cruise.CruiseCode) == -1) {
        this.selectedCruises.push(cruise.CruiseCode);
      }
    } else {
      console.log("not checked");
      let index = this.selectedCruises.indexOf(cruise.CruiseCode);
      if (index != -1) {
        this.selectedCruises.splice(index, 1);
      }
    }
    this.whatsapplead();
  }

  afterDataLoad() {
    for (let i = 0; i < this.availableCruises.length; i++) {
      //this.availableCruises[i].SailingDates = this.availableCruises[i].SailingDates.split(',');
      let months = this.availableCruises[i].sailMonths;
      if (this.filterNights.indexOf(this.availableCruises[i].Nights) == -1) {
        this.filterNights.push(this.availableCruises[i].Nights)
      }
      for (let m of months) {
        if (this.filterMonths.indexOf(m.sailM) == -1) {
          this.filterMonths.push(m.sailM);
        }
      }
      if (this.maxPrice < this.availableCruises[i].StartPrice) {
        this.maxPrice = this.availableCruises[i].StartPrice;
        this.selectedMaxPrice = this.maxPrice;
      }
      // if (this.filterDestinations.indexOf(this.availableCruises[i].Destination) == -1) {
      //   this.filterDestinations.push(this.availableCruises[i].Destination);
      // }
    }
    this.filteredCruises = this.availableCruises;
    setTimeout(() => {
      jQuery("#waitingIc").click();
      jQuery("#closeWaiting").click();
      jQuery('.modal-backdrop').remove();
    }, 1000);

    // jQuery("#closeWaiting").click();
    // jQuery('.modal-backdrop').remove();
    // jQuery('#waitingIcon').modal('toggle');
    // jQuery('#waitingIcon').hide();
    // jQuery('#waitingIcon').removeClass("show")
    this.applyFilter(this.availableCruises);
    this.filterDestinations.sort(); this.filterNights.sort();
    jQuery("#slider-range").slider({
      range: true,
      min: 0,
      max: this.maxPrice,
      values: [this.minPrice, this.maxPrice],
      slide: (event, ui) => {
        jQuery("#amount").val(+ ui.values[0] + " - " + ui.values[1]);
        this.selectedMinPrice = ui.values[0];
        this.selectedMaxPrice = ui.values[1];
        this.applyFilter(this.availableCruises);
      }
    });
    jQuery("#amount").val(jQuery("#slider-range").slider("values", 0) +
      " - " + jQuery("#slider-range").slider("values", 1));

    jQuery("#slider-range1").slider({
      range: true,
      min: 0,
      max: this.maxPrice,
      values: [this.minPrice, this.maxPrice],
      slide: (event, ui) => {
        jQuery("#amount1").val(+ ui.values[0] + " - " + ui.values[1]);
        this.selectedMinPrice = ui.values[0];
        this.selectedMaxPrice = ui.values[1];
        this.applyFilter(this.availableCruises);
      }
    });
    jQuery("#amount1").val(jQuery("#slider-range1").slider("values", 0) +
      " - " + jQuery("#slider-range1").slider("values", 1));
  }
  imageinfomation(data) {
    this.decimg = '';
    this.selectedCruise = data;
    this.deckPlanscheck = data.deckPlans;

  }
  updatdeckno(event) {
    this.decimg = "";
    this.choosdeck = event.target.value;
    for (let item of this.selectedCruise.deckPlans) {
      if (item.deckno == this.choosdeck) {
        this.decimg = item.imageURL;
      }
    }
  }
  setSelectedCruise(cruise) {
    this.selectedCruise = cruise;



    setTimeout(() => {
      // $('#horizontalTab').easyResponsiveTabs({
      //   type: 'default', //Types: default, vertical, accordion          
      // });
      // $('#staterooms').easyResponsiveTabs({
      //   type: 'default', //Types: default, vertical, accordion  
      //   startCollapsed: 'accordion'
      // });

      // $('#verticalTab').easyResponsiveTabs({
      //   type: 'default', //Types: default, vertical, accordion
      // });

      $('#staterooms').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion  
        startCollapsed: 'accordion'
      });

      $('.slideshow').owlCarousel({
        items: 1,
        autoplay: true,
        autoplayTimeout: 4500,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        lazyLoad: true,
        loop: true,
        nav: true,
        navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      });
    }, 1000);

  }

  updateMonthFilter(event, value) {
    if (event.target.checked) {
      this.selectedMonths.push(value);
    } else {
      if (this.selectedMonths.indexOf(value) != -1) {
        let index = this.selectedMonths.indexOf(value);
        this.selectedMonths.splice(index, 1);
      }
    }
    this.applyFilter(this.availableCruises);
  }

  updatePriceRangeFilter(event) {
    this.applyFilter(this.availableCruises);
  }

  updateNightsFilter(event, value) {
    if (event.target.checked) {
      this.selectedNights.push(value);
    } else {
      if (this.selectedNights.indexOf(value) != -1) {
        let index = this.selectedNights.indexOf(value);
        this.selectedNights.splice(index, 1);
      }
    }
    this.applyFilter(this.availableCruises);
  }

  updateDestinationFilter(event, value) {
    if (event.target.checked) {
      this.selectedDestinations.push(value);
    } else {
      if (this.selectedDestinations.indexOf(value) != -1) {
        let index = this.selectedDestinations.indexOf(value);
        this.selectedDestinations.splice(index, 1);
      }
    }
    this.applyFilter(this.availableCruises);
  }
  keyPress(event: any) {
    const pattern = /[0-9\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onlyAlphabets(e: any) {
    var retType = false;
    try {
      if (window.event) {
        var charCode = window.event.keyCode;
      }
      else if (e) {
        var charCode = e.which;
      }
      else { retType = true; }
      if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
        retType = true;
      else
        retType = false;
    }
    catch (err) {
    }
    return retType;
  }
  resetAll() {
    this.selectedDestinations = [];
    this.selectedNights = [];
    this.selectedMonths = [];
    this.selectedMinPrice = 0;
    this.selectedMaxPrice = this.maxPrice;
    this.applyFilter(this.availableCruises);
  }
  termc(event) {
    if (event.target.checked == true) {
      this.checkterm = 'check';
    }
    else {
      this.checkterm = '';
    }
  }
  applyFilter(allCruises: any[]) {
    let filterdCruise = allCruises;
    if (this.selectedMonths.length > 0) {
      filterdCruise = allCruises.filter(c => {
        let cp = c.cabinPrice.filter(cab => this.selectedMonths.indexOf(cab.SailingMonth) != -1);
        return cp.length > 0;
      });
    }

    if (this.selectedMinPrice != this.minPrice || this.selectedMaxPrice != this.maxPrice) {
      filterdCruise = filterdCruise.filter(c => {
        return (this.selectedMinPrice < c.StartPrice && this.selectedMaxPrice > c.StartPrice);
      })
    }

    if (this.selectedNights.length > 0) {
      filterdCruise = filterdCruise.filter(c => this.selectedNights.indexOf(c.Nights) != -1);
    }

    if (this.selectedDestinations.length > 0) {
      filterdCruise = filterdCruise.filter(c => c.Sailing.indexOf(this.selectedDestinations) != -1);
    }

    this.filteredCruises = filterdCruise;
    this.priceSorted = true;
    this.sorting('price');
    this.filterDestinations.sort(); this.filterNights.sort((a, b) => Number(a) - Number(b)); this.filtership.sort();

  }

  sorting(column) {
    if (column == 'cruiseLine') {
      if (this.cruiseLineSorted) {
        this.cruiseLineSorted = false;
        this.filteredCruises = this.filteredCruises.sort((a, b) => a.CruiseLine - b.CruiseLine);
      } else {
        this.cruiseLineSorted = true;
        this.filteredCruises = this.filteredCruises.sort((a, b) => a.CruiseLine - b.CruiseLine);
      }
    }
    if (column == 'cruiseLength') {
      if (this.cruiseLengthSorted) {
        this.cruiseLengthSorted = false;
        this.filteredCruises = this.filteredCruises.sort((a, b) =>
          Number(a.Nights.replace(" Nights", "")) - Number(b.Nights.replace(" Nights", "")));
      } else {
        this.cruiseLengthSorted = true;
        this.filteredCruises = this.filteredCruises.sort((a, b) =>
          Number(b.Nights.replace(" Nights", "")) - Number(a.Nights.replace(" Nights", "")));
      }
    }
    if (column == 'price') {
      if (this.priceSorted) {
        this.priceSorted = false;
        this.filteredCruises = this.filteredCruises.sort((a, b) => a.StartPrice - b.StartPrice);
      } else {
        this.priceSorted = true;
        this.filteredCruises = this.filteredCruises.sort((a, b) => b.StartPrice - a.StartPrice);
      }
    }
  }

  // shareitinerary() {
  //   if (!this.loginMobile) {
  //     this.toastr.warning("Please provide  Email...!");
  //     return false;
  //   } else {
  //     var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  //     if (!emailReg.test(this.loginMobile)) {
  //       this.toastr.warning("Please provide Correct Email...!");
  //       return false;
  //     }
  //   }
  //   for (let cruise of this.filteredCruises) {
  //     if (this.selectedCruises.indexOf(cruise.CruiseCode) > -1) {
  //       this.selectedCruiseArray.push(cruise);
  //     }
  //   }

  //   this.landingPageService.getShareItinerary(this.loginMobile, window.btoa(unescape(encodeURIComponent(JSON.stringify(this.selectedCruiseArray))))).subscribe(
  //     data => {
  //       let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
  //       if (resp.cruiseAvailability) {
  //         this.availableCruises = resp.cruiseAvailability;
  //         this.afterDataLoad();
  //       } else {
  //         this.toastr.info("Unable to find any matching Cruise! Try again")
  //       }
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //   )
  // }

  setCruiseNameForLead(cruise: any) {
    this.lead.cruiseName = cruise.CruiseCode;
  }

  createLead() {
    console.log(this.lead);
    if (this.lead.name == "") {
      this.toastr.warning("Name is required...!");
      return false;
    }
    if (!this.lead.email) {
      this.toastr.warning("Please provide Correct Email...!");
      return false;
    } else {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(this.lead.email)) {
        this.toastr.warning("Please provide Correct Email...!");
        return false;
      }
    }
    if (!this.lead.phone) {
      this.toastr.warning("Please provide 10 digit Mobile Number ...!");
      return false;
    } else {
      var mobileReg = /^(\d{10})?$/;
      if (!mobileReg.test(this.lead.phone)) {
        this.toastr.warning("Please provide Correct Mobile Number. 10 Digit...!");
        return false;
      }
    }
    if (this.checkterm == '') {
      this.toastr.warning("Authorize Akbartravels to contact me and have read the Terms and Conditions is Required...");
      return false;
    }
    this.cruiserService.createLead(this.lead, this.AgentUserLoginId, JSON.stringify(this.logindata)).subscribe(
      data => {
        this.toastr.success("Request Submitted successfully...!");
      },
      error => {
        this.toastr.error("Something went wrong...!")
      }
    )
    jQuery('.modal-backdrop').remove();
    jQuery('#login-signup1').modal('toggle');
    jQuery('#login-signup1').hide();
    jQuery('#login-signup1').removeClass("show");
    $('#leadModal').click();
  }

  submitlead() {
    if (!this.loginMobile) {
      this.toastr.warning("Please provide  Email...!");
      return false;
    } else {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      if (!emailReg.test(this.loginMobile)) {
        this.toastr.warning("Please provide Correct Email...!");
        return false;
      }
    }
    this.selectedCruiseArray = [];
    for (let cruise of this.filteredCruises) {
      if (this.selectedCruises.indexOf(cruise.CruiseCode) > -1) {
        this.selectedCruiseArray.push(cruise);
      }
    }

    this.landingPageService.getShareItinerary(this.loginMobile, JSON.stringify(this.selectedCruiseArray), JSON.stringify(this.logindata)).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == "Success") {
          this.toastr.info("Please check your email")
        } else {
          this.toastr.info("Unable to find any matching Cruise! Try again")
        }
      },
      error => {
        console.log(error);
      }
    )
    $('#shareSearch').click();
    $('.modal-backdrop').toggleClass('show');
    $('.modal-backdrop').remove();
  }

  whatsapplead() {
    this.selectedCruiseArray = [];
    for (let cruise of this.filteredCruises) {
      if (this.selectedCruises.indexOf(cruise.CruiseCode) > -1) {
        this.selectedCruiseArray.push(cruise);
      }
    }

    this.landingPageService.getWhatsAppMsg(this.loginType, JSON.stringify(this.selectedCruiseArray), JSON.stringify(this.logindata)).subscribe(
      data => {
        let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        if (resp.status == "Success") {
          this.whatsappmsg = resp.message;

        } else {

        }
      },
      error => {
        console.log(error);
      }
    )
    $('#shareSearch').click();
    $('.modal-backdrop').toggleClass('show');
    $('.modal-backdrop').remove();
  }

  bookNow(date, cruise) {
    $('.close').click();
    $('.modal-backdrop').toggleClass('show');
    $('.modal-backdrop').remove();
    var arr = date.split("-");
    //var d = new Date(arr[2] + "-" + arr[1] + "-" + arr[0]);
    //var datePipe = new DatePipe('en-US');
    let data = arr[2] + "-" + arr[1] + "-" + arr[0]; //datePipe.transform(d, 'yyyy-MM-dd');

    let url = cruise.CruiseLine.split('/')[0].split(' ').join('-') + "---" + cruise.ShipName.split(' ').join('-')
      + "---" + cruise.FriendlyCruiseName.split(' ').join('-') + "---"
      + cruise.Nights.split(' ').join('-') + "---" + data;
    if (isPlatformBrowser(this.platformId)) { sessionStorage.setItem("selectedCruise", JSON.stringify(cruise)); }
    this.routr.navigate(["cruise-details/" + cruise.CruiseLine.split('/')[0].split(' ')[0] + "/" + url]);
  }

  readMore() {
    this.showMore = !this.showMore;
    if (!this.showMore) {
      setTimeout(() => {
        window.scroll(0, 0);
      }, 150);
    }
  }

  createCanonicalLink(url?: string) {
    let canURL = url == undefined ? this.dom.URL : url;
    let link: HTMLLinkElement = this.dom.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', canURL);
  }
}
